import isEmpty from "lodash/isEmpty";
import { currencyCodes } from "../ProductTile/constants.js";
const concatWholeAndDecimal = (wholeValue, decimalValue) => {
  return wholeValue && decimalValue ? `${wholeValue}.${decimalValue}` : wholeValue ? wholeValue : "";
};
const formatPrice = (locale, price) => {
  if (!locale || !price)
    return { decimalValue: "", formattedPrice: "", wholeValue: "" };
  const options = {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: "decimal"
  };
  const formatter = new Intl.NumberFormat(locale, options);
  const formattedPrice = formatter.format(+price);
  const [wholeValue = "", decimalValue = ""] = locale === "fr-ca" ? formattedPrice.split(",") : formattedPrice.split(".");
  return { decimalValue, formattedPrice, wholeValue };
};
const removeDecimalsIfWhole = (price) => {
  return price.replace(/\.00$/, "");
};
const calculateSavings = (locale, listPrice, salePrice) => {
  if (!listPrice || !salePrice || salePrice < 0) {
    return {
      displaySavings: false,
      savingsAmount: ""
    };
  } else if (listPrice - salePrice > 0) {
    return {
      displaySavings: true,
      savingsAmount: new Intl.NumberFormat(locale, {
        currency: currencyCodes[locale],
        maximumFractionDigits: 0,
        style: "currency"
      }).format(listPrice - salePrice).replace("US", "").trim()
    };
  }
  return {
    displaySavings: false,
    savingsAmount: ""
  };
};
const generateDiscountText = (promoText, matchRegex, prefixText) => {
  if (!matchRegex || !prefixText) {
    return promoText;
  }
  const regex = new RegExp(matchRegex, "i");
  if (regex.test(promoText)) {
    return `${prefixText} ${promoText}`;
  }
  return promoText;
};
const displayPromoBreakdown = (enablePromoBreakdown, priceListData, locale, promoBreakdownCAProvince, displaySavings) => {
  if (enablePromoBreakdown && priceListData && !Array.isArray(priceListData.priceValue) && // For now, if a price range don't display
  locale.toLowerCase().includes("ca") && typeof promoBreakdownCAProvince === "string" && isEmpty(promoBreakdownCAProvince) && displaySavings) {
    return true;
  } else {
    return false;
  }
};
export {
  calculateSavings,
  concatWholeAndDecimal,
  displayPromoBreakdown,
  formatPrice,
  generateDiscountText,
  removeDecimalsIfWhole
};
